export type TutorialStep =
  | 'look'
  | 'move'
  | 'jump'
  | 'climb'
  | 'companion'
  | 'gate'
  | 'done';

const COPY: Record<TutorialStep, string> = {
  look: 'Look around — drag the mouse (or the right side of the screen on a phone)',
  move: 'Walk with WASD · hold Shift to run',
  jump: 'Press Space to jump',
  climb: 'Find a glowing ladder — or the south door into the keep',
  companion: 'Approach Mira — press E to take her hand',
  gate: 'Return to the courtyard lever by the gate — press E',
  done: 'The gate opens. Walk through into the light.',
};

export class Tutorial {
  private step: TutorialStep = 'look';
  private timer = 0;
  private moved = false;
  private el: HTMLElement;
  private onStep?: (step: TutorialStep) => void;

  constructor(el: HTMLElement, onStep?: (step: TutorialStep) => void) {
    this.el = el;
    this.onStep = onStep;
    this.render();
  }

  /** Fire dialogue for the current step once the game has started (after intro VO). */
  announceCurrent(): void {
    this.onStep?.(this.step);
  }

  getStep(): TutorialStep {
    return this.step;
  }

  noteLook(dt: number, looking: boolean): void {
    if (this.step !== 'look') return;
    if (looking) this.timer += dt;
    if (this.timer > 1.2) this.advance('move');
  }

  noteMove(moving: boolean): void {
    if (this.step !== 'move') return;
    if (moving) this.moved = true;
    if (this.moved) {
      this.timer += 0.016;
      if (this.timer > 1.5) this.advance('jump');
    }
  }

  noteJump(): void {
    if (this.step === 'jump') this.advance('climb');
  }

  noteClimb(): void {
    if (this.step === 'climb') this.advance('companion');
  }

  noteHand(): void {
    if (this.step === 'companion') this.advance('gate');
  }

  noteGate(): void {
    if (this.step === 'gate' || this.step === 'companion') this.advance('done');
  }

  private advance(next: TutorialStep): void {
    this.step = next;
    this.timer = 0;
    this.render();
    this.onStep?.(next);
    if (next === 'done') {
      window.setTimeout(() => this.el.classList.add('dim'), 4000);
    }
  }

  private render(): void {
    this.el.textContent = COPY[this.step];
    this.el.classList.remove('dim');
  }
}
